import {useFirebaseState} from "./firebaseContext";

export const useIsAuthenticated = () => {
    const {uid} = useFirebaseState()

    return Boolean(uid)
}